export default __webpack_public_path__ + "static/media/rs_powerPoint_icon.5f67c0cc.svg";